import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { AuthProvider } from "@/auth/AuthProvider";
import { Toaster } from "@/components/ui/toaster";
import { queryClient } from "@/lib/query";

import { router } from "./routes";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider
          router={router}
          future={{ v7_startTransition: true }}
        />
        <Toaster />
      </AuthProvider>
    </QueryClientProvider>
  );
}
